import {observer} from 'mobx-react-lite'
import GameTeamsList from "../../Games/GameTeamsList";

const TrainerGameTeams = () => {
  return (
    <GameTeamsList role={'TRN'}/>
  )
}

export default observer(TrainerGameTeams)